import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import {  Box, useTheme } from '@mui/material'

import { coreFunctions, getReplaceTitle } from '../../utils'
import { fileActions, addTitleLegoCurrent } from '../../store/actions'
import { GenericButtonList, CustomLoadingOverlay, GenericContainer, GenericStatusElement } from '../../components'
import { useTranslation } from 'react-i18next'

export default function SelectOptionsComponents(props) {
    const theme = useTheme()
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [loadView, setLoadView] = useState(false)
    const [options, setOptions] = useState([])
    const [selectedOp, setSelectedOp] = useState('')
    const [fileId, setFileId] = useState('')

    const file = useSelector(state => state.FileInfo)
    const selection = useSelector(state => state.OptionsToSelect)
    const { t } = useTranslation();

    const actorId = location.state.actorId

    const data = {
        File_Id: fileId,
        Actor_Id: actorId,
        Selection: selectedOp
    }

    useEffect(() => {
        dispatch(addTitleLegoCurrent("Selección"))
        setLoadView(true)
        setFileId(location.state.folioId)
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        getReplaceTitle("Onboarding")
    }, [])

    useEffect(() => {
        if (selectedOp != '') {
            setLoadView(true)
            dispatch(fileActions.SetOptionsToSelect(data))
        }
    }, [selectedOp])

    useEffect(() => {
        if (selection.items != undefined && loadView) {
            // console.log('selection', selection.items)
            setSelectedOp('')
            // console.log('items from selectOp', selection.items)
            let stageName = selection.items.Stage.Name
            let stageId = selection.items.Stage.Id
            let stage = selection.items.Stage
            let folioId = fileId

            let optionsValues = selection.items.Stage?.Properties?.find(item => item.Name == "Options")
            if (optionsValues != null && optionsValues?.Value != undefined && optionsValues?.Value != null
                && optionsValues?.Value != "") {
                let optionsArray = JSON.parse(optionsValues?.Value);


                setLoadView(false)
                dispatch(addTitleLegoCurrent(selection.items.Stage.Description))
                // setTitleTex(selection.items.Stage.Description)
                setOptions(optionsArray)
            }
            let nextComponent = coreFunctions.GetLegoNext(stageName)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
        }

        if (selection.error != undefined && loadView) {
            setLoadView(false)
            alert(selection.error)
        }
    }, [selection])

    useEffect(() => {
        if (file.items != undefined && loadView) {
            console.log('file info', file.items)
            console.log('file.items.Stage.Properties', file.items.Stage.Properties)
            console.log('file.items.Stage.Properties', file.items.Stage.Properties.find(item => item.Name == "Options"))

            let optionsValues = file.items.Stage?.Properties?.find(item => item.Name == "Options")
            let optionsArray = JSON.parse(optionsValues?.Value);

            // if (file.items?.Stage?.StageExitRoutes.length > 0) {
            setLoadView(false)
            // setTitleTex(file.items.Stage.Description)
            dispatch(addTitleLegoCurrent(file.items.Stage.Description))
            setOptions(optionsArray)
            // setCurrentStage(file.items.Stage.CurrentStageGroup)
            // setTotalStage(file.items.Stage.TotalStageGroups)
            // }
        }
    }, [file])

    // useEffect(() => {
    //     if (stageProps != 0) {
    //         setCurrentStage(stageProps.CurrentStageGroup)
    //         setTotalStage(stageProps.TotalStageGroups)
    //     }
    // }, [stageProps])

    // useEffect(() => {
    //     let stageName = location.state.stageName
    //     let stageId = location.state.stageId

    //     if (wf.items != undefined) {
    //         let items = wf.items
    //         items.forEach(i => {
    //             let stages = i.Stages
    //             let stgPrp = stages.find(j => j.Id === stageId && j.Name === stageName)
    //             setStageProps(stgPrp)
    //         });
    //     }
    // }, [wf])

    return (<GenericContainer>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        {/* <Typography variant="h6" >{titleTex}</Typography> */}
        <Box sx={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            {options.map((op, index) => {
                return <GenericButtonList
                    key={`${index}`}
                    onClick={() => {
                        setSelectedOp(op.Status)
                    }}
                >
                    <GenericStatusElement
                        key={`${index}_${op.Title}`}
                        icon={op.Icon}
                        text={op.Title} />
                </GenericButtonList>

                // return <Button
                //     className={gridContainer.buttonList}
                //     key={`btn_key_op_${op.Title}`}
                //     onClick={() => { setSelectedOp(op.Status) }}
                // >
                //     <ListElement
                //         key={`list_element_key_${op.Title}`}
                //         text={op.Title}
                //         icon={op.Icon}
                //         description={`${op.Description}`} />
                // </Button>
            })}
        </Box>
    </GenericContainer>)
}